/**
 * Custom Sections Interactive Enhancements (Sections 1, 2, 3, 4)
 * Handles carousels, mobile 2.2 slide view, mobile grid toggle, video playback, and AJAX cart.
 */

(function () {
  'use strict';

  function initAll() {
    initCarousels();
    initSec1MobileGrid();
    initSec2Videos();
    initSec2ProductPills();
    initSec4ShopNow();
    initProductTabsSlider();
    initProductAccordions();
    if (window.initCusHeader) window.initCusHeader();
  }

  /* ==========================================================================
     1. CAROUSEL ENGINE
     ========================================================================== */
  function initCarousels() {
    const carousels = document.querySelectorAll('[data-replo-carousel="true"]');

    carousels.forEach(function (carousel) {
      const track = carousel.querySelector('[data-replo-part="slide-track"]');
      if (!track) return;

      // Prevent duplicate initialization
      if (carousel.dataset.cusInitialized === 'true') return;
      carousel.dataset.cusInitialized = 'true';

      const prevBtn = carousel.querySelector('button[data-direction="previous"]');
      const nextBtn = carousel.querySelector('button[data-direction="next"]');

      // Strip initial hardcoded Replo disabled classes from previous button
      if (prevBtn) {
        prevBtn.classList.remove('ds1-r-q5huwr', 'ds3-r-66vum7', 'ds3-r-klxr6t', 'ds3-r-124wh61');
      }

      // Filter visible real slides (exclude clone slides and hidden ones)
      function getVisibleSlides() {
        return Array.from(track.querySelectorAll('[data-replo-part="slide"]')).filter(function (slide) {
          const idx = parseInt(slide.getAttribute('data-slide-index'), 10);
          return !isNaN(idx) && idx >= 0 && getComputedStyle(slide).display !== 'none';
        });
      }

      // Find or setup continuous progress bar
      const indicatorContainer = carousel.querySelector(
        '.ds1-r-xyy1hi, .ds3-r-rjbngq, .ds3-r-1lp9f6e, .ds3-r-ywi9n6'
      );

      let progressThumb = null;
      if (indicatorContainer) {
        progressThumb = indicatorContainer.querySelector('.cus-progress-thumb');
        if (!progressThumb) {
          progressThumb = document.createElement('div');
          progressThumb.className = 'cus-progress-thumb';
          indicatorContainer.appendChild(progressThumb);
        }
      }

      function updateActiveState() {
        const slides = getVisibleSlides();
        if (!slides.length) return;

        const trackLeft = track.scrollLeft;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

        // Check if currently at start
        const isAtStart = trackLeft <= 6;

        // Check if currently at end: either maxScroll reached or last slide fully visible
        const lastSlide = slides[slides.length - 1];
        const lastSlideRight = lastSlide ? (lastSlide.offsetLeft - track.offsetLeft + lastSlide.offsetWidth) : 0;
        const isAtEnd = maxScroll > 0 && (
          trackLeft >= maxScroll - 8 ||
          (lastSlideRight > 0 && lastSlideRight <= trackLeft + track.clientWidth + 8)
        );

        // Update Prev Button disabled & active states
        if (prevBtn) {
          if (isAtStart) {
            prevBtn.disabled = true;
            prevBtn.setAttribute('aria-disabled', 'true');
            prevBtn.classList.add('is-disabled');
            prevBtn.style.setProperty('opacity', '0.25', 'important');
            prevBtn.style.setProperty('pointer-events', 'none', 'important');
            prevBtn.style.setProperty('cursor', 'not-allowed', 'important');
            prevBtn.style.setProperty('border-color', 'rgba(98, 40, 4, 0.25)', 'important');
          } else {
            prevBtn.disabled = false;
            prevBtn.setAttribute('aria-disabled', 'false');
            prevBtn.classList.remove('is-disabled', 'ds1-r-q5huwr', 'ds3-r-66vum7', 'ds3-r-klxr6t', 'ds3-r-124wh61');
            prevBtn.style.setProperty('opacity', '1', 'important');
            prevBtn.style.setProperty('pointer-events', 'auto', 'important');
            prevBtn.style.setProperty('cursor', 'pointer', 'important');
            prevBtn.style.setProperty('border-color', '#622804', 'important');
          }
        }

        // Update Next Button disabled & active states
        if (nextBtn) {
          if (isAtEnd || maxScroll <= 1) {
            nextBtn.disabled = true;
            nextBtn.setAttribute('aria-disabled', 'true');
            nextBtn.classList.add('is-disabled');
            nextBtn.style.setProperty('opacity', '0.25', 'important');
            nextBtn.style.setProperty('pointer-events', 'none', 'important');
            nextBtn.style.setProperty('cursor', 'not-allowed', 'important');
            nextBtn.style.setProperty('border-color', 'rgba(98, 40, 4, 0.25)', 'important');
          } else {
            nextBtn.disabled = false;
            nextBtn.setAttribute('aria-disabled', 'false');
            nextBtn.classList.remove('is-disabled');
            nextBtn.style.setProperty('opacity', '1', 'important');
            nextBtn.style.setProperty('pointer-events', 'auto', 'important');
            nextBtn.style.setProperty('cursor', 'pointer', 'important');
            nextBtn.style.setProperty('border-color', '#622804', 'important');
          }
        }

        // Update Progress Bar Thumb position & width
        if (indicatorContainer && progressThumb) {
          const containerWidth = indicatorContainer.clientWidth || 100;
          if (maxScroll <= 1) {
            progressThumb.style.width = '100%';
            progressThumb.style.transform = 'translateX(0px)';
          } else {
            let progress = 0;
            if (isAtEnd) {
              progress = 1.0;
            } else if (isAtStart) {
              progress = 0.0;
            } else {
              progress = Math.min(1, Math.max(0, trackLeft / maxScroll));
            }

            const visibleRatio = Math.min(0.5, Math.max(0.2, track.clientWidth / (track.scrollWidth || 1)));
            const thumbWidth = Math.max(28, Math.round(containerWidth * visibleRatio));
            const maxTravel = Math.max(0, containerWidth - thumbWidth);
            const thumbX = Math.round(progress * maxTravel);

            progressThumb.style.width = thumbWidth + 'px';
            progressThumb.style.transform = 'translateX(' + thumbX + 'px)';
            progressThumb.style.webkitTransform = 'translateX(' + thumbX + 'px)';
          }
        }
      }

      // Next button click handler
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (nextBtn.disabled || nextBtn.classList.contains('is-disabled')) return;
          const slides = getVisibleSlides();
          if (!slides.length) return;

          const trackLeft = track.scrollLeft;
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

          // Find first slide whose left is at least 15px ahead of current trackLeft
          let targetLeft = maxScroll;
          for (let i = 0; i < slides.length; i++) {
            const sLeft = slides[i].offsetLeft - track.offsetLeft;
            if (sLeft > trackLeft + 15) {
              targetLeft = Math.min(sLeft, maxScroll);
              break;
            }
          }

          track.scrollTo({
            left: targetLeft,
            behavior: 'smooth'
          });

          setTimeout(updateActiveState, 150);
          setTimeout(updateActiveState, 350);
          setTimeout(updateActiveState, 500);
        });
      }

      // Previous button click handler
      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (prevBtn.disabled || prevBtn.classList.contains('is-disabled')) return;
          const slides = getVisibleSlides();
          if (!slides.length) return;

          const trackLeft = track.scrollLeft;

          // Find last slide whose left is at least 15px before current trackLeft
          let targetLeft = 0;
          for (let i = slides.length - 1; i >= 0; i--) {
            const sLeft = slides[i].offsetLeft - track.offsetLeft;
            if (sLeft < trackLeft - 15) {
              targetLeft = Math.max(0, sLeft);
              break;
            }
          }

          track.scrollTo({
            left: targetLeft,
            behavior: 'smooth'
          });

          setTimeout(updateActiveState, 150);
          setTimeout(updateActiveState, 350);
          setTimeout(updateActiveState, 500);
        });
      }

      // Click on Progress Bar Track to seek
      if (indicatorContainer) {
        indicatorContainer.addEventListener('click', function (e) {
          const rect = indicatorContainer.getBoundingClientRect();
          if (rect.width <= 0) return;
          const clickX = e.clientX - rect.left;
          const clickRatio = Math.max(0, Math.min(1, clickX / rect.width));
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          track.scrollTo({
            left: clickRatio * maxScroll,
            behavior: 'smooth'
          });
          setTimeout(updateActiveState, 150);
          setTimeout(updateActiveState, 350);
        });
      }

      // Track scroll event
      let isScrolling = false;
      track.addEventListener('scroll', function () {
        if (!isScrolling) {
          window.requestAnimationFrame(function () {
            updateActiveState();
            isScrolling = false;
          });
          isScrolling = true;
        }
      }, { passive: true });

      // Mouse Drag-to-Scroll support on desktop
      let isMouseDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let dragged = false;

      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        isMouseDown = true;
        dragged = false;
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });

      window.addEventListener('mousemove', function (e) {
        if (!isMouseDown) return;
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 1.2;
        if (Math.abs(walk) > 5) {
          dragged = true;
        }
        track.scrollLeft = scrollLeft - walk;
      });

      window.addEventListener('mouseup', function (e) {
        if (!isMouseDown) return;
        isMouseDown = false;
        track.classList.remove('is-dragging');
      });

      // Prevent link clicks during drag
      track.addEventListener('click', function (e) {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      // Initial state calculation
      setTimeout(updateActiveState, 60);
      setTimeout(updateActiveState, 200);
      setTimeout(updateActiveState, 500);
      window.addEventListener('resize', updateActiveState);
    });
  }

  /* ==========================================================================
     2. SECTION 1: MOBILE 2x2 GRID & "SEE MORE (2)" TOGGLE
     ========================================================================== */
  function initSec1MobileGrid() {
    const seeMoreBtn = document.querySelector('.ds1-r-1961370');
    const extraCards = document.querySelector('.ds1-r-xqj9bj');

    if (seeMoreBtn && extraCards) {
      if (seeMoreBtn.dataset.cusInitialized === 'true') return;
      seeMoreBtn.dataset.cusInitialized = 'true';

      const btnText = seeMoreBtn.querySelector('p');

      seeMoreBtn.addEventListener('click', function (e) {
        e.preventDefault();
        const isExpanded = extraCards.classList.contains('is-expanded');

        if (isExpanded) {
          extraCards.classList.remove('is-expanded');
          if (btnText) btnText.textContent = 'see more (2)';
        } else {
          extraCards.classList.add('is-expanded');
          if (btnText) btnText.textContent = 'see less';
        }
      });
    }

    // Fix external shop all links to internal store collection
    document.querySelectorAll('.ds1-r-14a75pe, .ds1-r-2r8l54').forEach(function (link) {
      if (link.getAttribute('href')?.includes('blackgirlvitamins.co/collections/all-products')) {
        link.setAttribute('href', '/collections/all-products');
      }
    });

    // Make Section 1 collection cards clickable
    const cardSelectors = '.ds1-r-12dld60, .ds1-r-cw0snx, .ds1-r-1ghbunu, .ds1-r-aqny6t, .ds1-r-ozhfx5, .ds1-r-1gm3dhe, .ds1-r-1ghswaj, .ds1-r-1e88lzh, .ds1-r-tuv90j, .ds1-r-w6owk1, .ds1-r-19huxbi, .ds1-r-2du08h';
    document.querySelectorAll(cardSelectors).forEach(function (card) {
      if (card.dataset.cardNavInit === 'true') return;
      card.dataset.cardNavInit = 'true';
      card.style.cursor = 'pointer';

      card.addEventListener('click', function (e) {
        const href = card.getAttribute('href');
        if (href && !e.defaultPrevented) {
          window.location.href = href;
        }
      });
    });
  }

  /* ==========================================================================
     3. SECTION 2: VIDEO PLAY/PAUSE FUNCTIONALITY
     ========================================================================== */
  function initSec2Videos() {
    const videoSlides = document.querySelectorAll(
      '.ds3-r-11zfzph, .ds3-r-ru84fg, .ds3-r-i7fe8j'
    );

    videoSlides.forEach(function (card) {
      if (card.dataset.cusVideoInit === 'true') return;
      card.dataset.cusVideoInit = 'true';

      const video = card.querySelector('video');
      const playBtn = card.querySelector('.ds3-r-kvoknk, .ds3-r-1wpxzc0, .ds3-r-1nzvdqb');
      const playOverlay = card.querySelector('.ds3-r-bx8613, .ds3-r-u5a0ud, .ds3-r-1owk0ty');

      if (!video) return;

      function togglePlay() {
        if (video.paused) {
          // Pause any other playing video on page
          document.querySelectorAll('video').forEach(function (v) {
            if (v !== video && !v.paused) {
              v.pause();
            }
          });

          video.play().then(function () {
            card.classList.add('is-video-playing');
          }).catch(function (err) {
            console.log('Video play interrupted:', err);
          });
        } else {
          video.pause();
          card.classList.remove('is-video-playing');
        }
      }

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          togglePlay();
        });
      }

      // Clicking video container directly also toggles playback
      video.addEventListener('click', function (e) {
        e.stopPropagation();
        togglePlay();
      });

      video.addEventListener('ended', function () {
        card.classList.remove('is-video-playing');
      });

      video.addEventListener('pause', function () {
        card.classList.remove('is-video-playing');
      });
    });
  }

  /* ==========================================================================
     4. SECTION 4: SHOP NOW REDIRECTION TO RESPECTIVE PRODUCT PAGES
     ========================================================================== */
  function initSec4ShopNow() {
    const shopButtons = document.querySelectorAll(
      '.ds3-r-1f1o1fw, .ds3-r-1dao42h, .ds3-r-11ljikb'
    );

    const fallbackUrls = {
      'ds3-r-1dao42h': '/products/look-good-feel-good-bundle',
      'ds3-r-11ljikb': '/products/beauty-bundle',
      'ds3-r-1f1o1fw': '/products/gut-health-essentials'
    };

    shopButtons.forEach(function (btn) {
      if (btn.dataset.cusRedirectInit === 'true') return;
      btn.dataset.cusRedirectInit = 'true';

      btn.style.cursor = 'pointer';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Determine destination product URL from container attribute
        let targetUrl = '';
        const container = btn.closest('[data-replo-product-handle]');
        if (container) {
          const handle = container.getAttribute('data-replo-product-handle');
          if (handle) {
            targetUrl = '/products/' + handle;
          }
        }

        // Fallback matching by specific button class
        if (!targetUrl) {
          const entries = Object.entries(fallbackUrls);
          for (let i = 0; i < entries.length; i++) {
            const cls = entries[i][0];
            const url = entries[i][1];
            if (btn.classList.contains(cls)) {
              targetUrl = url;
              break;
            }
          }
        }

        if (!targetUrl) {
          targetUrl = '/collections/all-products';
        }

        window.location.href = targetUrl;
      });
    });
  }

  /* ==========================================================================
     5. SECTION 2: PRODUCT PILLS REDIRECTION
     ========================================================================== */
  function initSec2ProductPills() {
    const pills = document.querySelectorAll(
      '.ds3-r-t6l8kv, .ds3-r-qvjma6, .ds3-r-1k05bb3, .ds3-r-1fagxga, [data-product-url]'
    );

    const classUrls = {
      'ds3-r-t6l8kv': '/products/d3-sugar-free',
      'ds3-r-qvjma6': '/products/meno-chill',
      'ds3-r-1k05bb3': '/products/bgv-collagen-powder',
      'ds3-r-1fagxga': '/products/look-good-feel-good'
    };

    pills.forEach(function (pill) {
      if (pill.dataset.cusPillInit === 'true') return;
      pill.dataset.cusPillInit = 'true';

      pill.style.cursor = 'pointer';

      pill.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        let targetUrl = pill.dataset.productUrl || pill.getAttribute('data-product-url');

        if (!targetUrl) {
          const entries = Object.entries(classUrls);
          for (let i = 0; i < entries.length; i++) {
            const cls = entries[i][0];
            const url = entries[i][1];
            if (pill.classList.contains(cls)) {
              targetUrl = url;
              break;
            }
          }
        }

        if (!targetUrl) {
          targetUrl = '/collections/all-products';
        }

        window.location.href = targetUrl;
      });
    });
  }

  /* ==========================================================================
     6. PRODUCT TABS SECTION: MOBILE CAROUSEL CONTROLS
     ========================================================================== */
  function initProductTabsSlider() {
    const tabSections = document.querySelectorAll('.section--product-tabs');

    tabSections.forEach(function (section) {
      const tabsComponent = section.querySelector('tabs-component');
      const panels = section.querySelectorAll('.tabs__content');
      const tabButtons = section.querySelectorAll('.tabs__tab');

      function updateSliderForPanel(panel) {
        if (!panel || panel.hidden || getComputedStyle(panel).display === 'none') return;
        const track = panel.querySelector('.swipe-mobile');
        const controls = panel.querySelector('.product-tabs__nav-controls');
        if (!track || !controls) return;

        const progressTrack = controls.querySelector('.product-tabs__progress-track');
        const thumb = controls.querySelector('.product-tabs__progress-thumb');
        const prevBtn = controls.querySelector('.product-tabs__arrow--prev');
        const nextBtn = controls.querySelector('.product-tabs__arrow--next');
        if (!progressTrack || !thumb) return;

        const trackWidth = progressTrack.clientWidth || 100;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

        if (maxScroll <= 4) {
          if (prevBtn) {
            prevBtn.disabled = true;
            prevBtn.style.opacity = '0.3';
          }
          if (nextBtn) {
            nextBtn.disabled = true;
            nextBtn.style.opacity = '0.3';
          }
          thumb.style.width = '36px';
          thumb.style.transform = 'translateX(0px)';
          return;
        }

        const progress = Math.min(1, Math.max(0, track.scrollLeft / maxScroll));
        const visibleRatio = Math.min(0.5, Math.max(0.2, track.clientWidth / (track.scrollWidth || 1)));
        const thumbWidth = Math.max(32, Math.round(trackWidth * visibleRatio));
        const maxTravel = Math.max(0, trackWidth - thumbWidth);
        const thumbX = Math.round(progress * maxTravel);

        thumb.style.width = thumbWidth + 'px';
        thumb.style.transform = 'translateX(' + thumbX + 'px)';

        if (prevBtn) {
          prevBtn.disabled = track.scrollLeft <= 4;
          prevBtn.style.opacity = prevBtn.disabled ? '0.3' : '1';
        }
        if (nextBtn) {
          nextBtn.disabled = track.scrollLeft >= maxScroll - 6;
          nextBtn.style.opacity = nextBtn.disabled ? '0.3' : '1';
        }
      }

      panels.forEach(function (panel) {
        const track = panel.querySelector('.swipe-mobile');
        const controls = panel.querySelector('.product-tabs__nav-controls');
        if (!track || !controls) return;

        const prevBtn = controls.querySelector('.product-tabs__arrow--prev');
        const nextBtn = controls.querySelector('.product-tabs__arrow--next');

        track.addEventListener('scroll', function () {
          updateSliderForPanel(panel);
        }, { passive: true });

        if (prevBtn) {
          prevBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const firstCard = track.querySelector('.f-column');
            const step = firstCard ? (firstCard.offsetWidth + 16) : 280;
            track.scrollBy({ left: -step, behavior: 'smooth' });
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const firstCard = track.querySelector('.f-column');
            const step = firstCard ? (firstCard.offsetWidth + 16) : 280;
            track.scrollBy({ left: step, behavior: 'smooth' });
          });
        }
      });

      // Tab button clicks
      tabButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          setTimeout(function () {
            const active = section.querySelector('.tabs__content:not([hidden])');
            if (active) updateSliderForPanel(active);
          }, 50);
          setTimeout(function () {
            const active = section.querySelector('.tabs__content:not([hidden])');
            if (active) updateSliderForPanel(active);
          }, 250);
        });
      });

      if (tabsComponent) {
        tabsComponent.addEventListener('tabChange', function () {
          setTimeout(function () {
            const active = section.querySelector('.tabs__content:not([hidden])');
            if (active) updateSliderForPanel(active);
          }, 60);
          setTimeout(function () {
            const active = section.querySelector('.tabs__content:not([hidden])');
            if (active) updateSliderForPanel(active);
          }, 250);
        });
      }

      // Initial layout update for active panel
      const initialActive = section.querySelector('.tabs__content:not([hidden])') || panels[0];
      if (initialActive) {
        setTimeout(function () { updateSliderForPanel(initialActive); }, 100);
        setTimeout(function () { updateSliderForPanel(initialActive); }, 400);
      }

      window.addEventListener('resize', function () {
        const active = section.querySelector('.tabs__content:not([hidden])');
        if (active) updateSliderForPanel(active);
      }, { passive: true });
    });
  }

  /* ==========================================================================
     PRODUCT PAGE ACCORDIONS (NATIVE DETAILS / SUMMARY)
     ========================================================================== */
  function initProductAccordions() {
    const accordions = document.querySelectorAll('.c2-pt-v2-accordion');
    accordions.forEach(function (acc) {
      if (acc.dataset.cusAccBound === 'true') return;
      acc.dataset.cusAccBound = 'true';

      const items = acc.querySelectorAll('details.c2-pt-acc-item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (this.open) {
            items.forEach(function (other) {
              if (other !== item && other.open) {
                other.open = false;
              }
            });
          }
        });
      });
    });
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support Shopify Theme Customizer section reload events
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();
